<template>
  <div class="inquiry_index">
    <div class="inquiry_cate">
      <el-icon class="el-icon-document-copy"></el-icon> 询报价记录
    </div>
    <div class="inquiry_radio">
      <el-radio-group v-model="state">
        <el-radio-button label="-1" class="inquiry_radoi_btn"><i class="el-icon-menu"></i>所有</el-radio-button>
        <el-radio-button label="0" class="inquiry_radoi_btn"><i class="el-icon-time"></i>待报价</el-radio-button>
        <el-radio-button label="1" class="inquiry_radoi_btn"><i class="el-icon-circle-check"></i>已报价</el-radio-button>
        <el-radio-button label="2" class="inquiry_radoi_btn"><i class="el-icon-circle-close"></i>已取消</el-radio-button>
      </el-radio-group>
    </div>
    <div class="inquiry_box" v-infinite-scroll="loadMore">
      <div class="inquiry_empty" v-if="inquirys.length<=0">
        暂无记录
      </div>
      <div class="inquiry_one" v-for="(item,index) in inquirys" :key="index" @click="toReview(item.oid)">
        <div class="inquiry_title">
          <div class="inquiry_left">
            {{item.ship_name}}
          </div>
          <div class="inquiry_right">
            <div class="inquiry_goto">
              »
            </div>
            <div class="inquiry_state" :style="`color:`+statesColor[item.state]+`;border:1px solid `+statesColor[item.state]+`;`">
              {{states[item.state]}}
            </div>
            <div class="inquiry_risk" :style="`font-weight:bold;color:`+(item.risk_score && item.risk_score > 0 ? riskColor[item.risk_score] : 'grey')+`;border:1px solid `+(item.risk_score && item.risk_score > 0 ? riskColor[item.risk_score] : 'grey')+`;`">
              风控评分:{{item.risk_score}}
            </div>
          </div>
        </div>
        <div class="inquiry_info">
          <div v-if="item.risk_info && item.risk_info!=null">
            <el-tag size="mini" type="danger" v-for="(value,key,index) in JSON.parse(item.risk_info)" :key="index" v-if="index<=0">{{ key+':'+value }}</el-tag>
            <span>进入查看更多风险提示</span>
          </div>
          <div v-else>
            <el-tag size="mini" type="info">暂无风险提示</el-tag>
          </div>
        </div>
        <div class="inquiry_info">
          <div class="inquiry_left">
            类型: {{item.ship_type}}
          </div>
          <div class="inquiry_right">
            所有人: {{item.ship_owner}}
          </div>
        </div>
        <div class="inquiry_info">
          <div class="inquiry_info_left">
            吨位: {{item.gross_tonnage}}
          </div>
          <div class="inquiry_info_middle">
            船籍港: {{item.home_port}}
          </div>
          <div class="inquiry_info_right">
            航区: {{area_types[item.area]}}
          </div>
        </div>
        <div class="inquiry_info">
          主条款: <el-tag size="mini" v-for="prd in products" :key="prd.id" v-if="item.insurance_products && item.insurance_products != null && item.insurance_products === prd.id">{{ prd.title }}</el-tag>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { insuranceOrderQuoteSearch,getInsuranceProductsAll } from '../../api/api'

  export default {
    name: "InquiryIndex",
    data() {
      return {
        inquirys:[],
        params:{'state':0},
        page:1,
        state:-1,
        size:10,
        loading:false,
        products:[],
        area_types:['内河','远洋','沿海'],
        states:['待报价','已报价','已取消'],
        statesColor:['#59c2e4','#f1c16b','#8f8f8f'],
        riskColor:['#8f8f8f','#f56c6c','#e6a23c','#59c2e4','#67c23a','#ff43d9']
      }
    },
    mounted() {
      getInsuranceProductsAll().then(res => {
        if(res && res.status === 0 && res.data){
          this.products = res.data;
        }
      });
    },
    methods: {
      loadMore(){
        if (!this.loading) {
          this.loading = true;
          let params = JSON.parse(JSON.stringify(this.params));
          params['state'] = this.state;
          params['page'] = this.page;
          params['size'] = this.size;
          insuranceOrderQuoteSearch(params).then(res => {
            if (res && res.status === 0 && res.data) {
              for (let d in res.data) {
                this.inquirys.push(res.data[d]);
              }
              this.page++;
            }
            this.loading = false;
          });
        }
      },
      showRisk(risk){
        let message = '';
        for(let r in risk){
          message += '<p style="color:red;">'+r+':'+risk[r]+'</p>';
        }
        this.$alert(message, '风险提示', {
          confirmButtonText: '关闭',
          dangerouslyUseHTMLString: true,
          center: true
        });
      },
      toReview(oid){
        this.$router.push('/quote/review?oid='+oid);
      }
    },
    watch:{
      state(val,oval){
        this.state = val;
        this.page = 1;
        this.size = 10;
        this.inquirys = [];
        this.loadMore();
      }
    }
  }
</script>

<style scoped>
  .inquiry_index {
    top: 6vh;
    left: 0;
    position: absolute;
    height: 94vh;
    width: 100%;
    margin: 0;
    background-color: #fefefe;
  }
  .inquiry_box {
    position:absolute;
    top:11vh;
    height:80vh;
    width:94%;
    margin:1vh 3%;
    overflow-y: scroll;
  }
  .inquiry_cate {
    font-size:.9rem;
    font-weight:bold;
    height:2rem;
    line-height:2rem;
    text-indent: .3rem;
    color:#03a7d5;
    position:fixed;
    top:7vh;
  }
  .inquiry_radio{
    background:white;
    position:fixed;
    width:100%;
    text-align:center;
    padding:0;
    margin:0;
    top:12vh;
  }
  .inquiry_one {
    width:97%;
    height:9rem;
    margin:1vh 0;
    padding:0 1%;
    background:#f9f9f9;
    border:1px solid #ccc;
    border-radius:.3rem;
  }
  .inquiry_title {
    height:2rem;
    line-height:2rem;
    font-size:.8rem;
    font-weight:bold;
    color:#3f3f3f;
    width:100%;
    border-bottom:1px dashed grey;
  }
  .inquiry_info {
    float:left;
    height:1.4rem;
    line-height:1.4rem;
    width:100%;
    font-size:.75rem;
    margin:.1rem 0;
    color:grey;
    text-align:left;
    overflow-x:hidden;
  }
  .inquiry_left {
    width:50%;
    float:left;
    overflow-x: hidden;
  }
  .inquiry_right {
    width:50%;
    float:right;
    overflow-x: hidden;
  }
  .inquiry_empty {
    width:100%;
    text-align:center;
    color:grey;
  }
  .inquiry_risk {
    float:right;
    font-size:.75rem;
    height:1.3rem;
    line-height:1.3rem;
    width:4.2rem;
    text-align:center;
    border-radius:.3rem;
    margin-top:.3rem;
    margin-right:.3rem;
  }
  .inquiry_state {
    float:right;
    font-size:.75rem;
    height:1.3rem;
    line-height:1.3rem;
    width:3rem;
    text-align:center;
    border-radius:.3rem;
    margin-top:.3rem;
  }
  .inquiry_goto {
    float:right;
    color:#aaa;
    margin: 0 .5rem;
  }
  .inquiry_info_left {
    width:33%;
    float:left;
    overflow-x: hidden;
  }
  .inquiry_info_middle {
    width:33%;
    float:left;
    overflow-x: hidden;
  }
  .inquiry_info_right {
    width:33%;
    float:left;
    overflow-x: hidden;
  }
  .inquiry_radoi_btn {
    width:25%;
    text-align:center;
  }
</style>



// WEBPACK FOOTER //
// src/components/quote/index.vue